import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import { ConfiguracionFincaService } from "../../../../generated/grpc/configuracion_finca_pb";
import {
  fromClienteFincaBaseResponse,
  grpcFincaLoteDatabase,
  toClienteFincaBaseResponseFromConfiguracionItem,
} from "../../../terceros/database/GrpcFincaLoteDatabase";
import { ClienteFincaBaseResponse } from "../../../terceros/response/ClienteFincaBaseResponse";
import { fx_createLoteGrpcService } from "../../../terceros/services/LoteGrpcService";
import { FincaArbolesRequest } from "../request/FincaArbolesRequest";

/** Servicio de guardado de los árboles a monitorear de una finca
 *  (`ConfiguracionFincaService.GuardarArboles`, gRPC-Web — antes
 *  `POST /configuracion/fincas-arboles/save`, ver CLAUDE.md del Server,
 *  sección migración a gRPC-Web). Devuelve la finca actualizada completa,
 *  mismo shape que ya devolvía REST. */
export class FincaArbolesSaveService
  implements ISaveService<FincaArbolesRequest, ClienteFincaBaseResponse>
{
  async saveAsync(request: FincaArbolesRequest): Promise<ClienteFincaBaseResponse> {
    const client = createClient(ConfiguracionFincaService, grpcTransportProvider.get());

    let saved;
    try {
      saved = await client.guardarArboles({
        fincaId: request.id,
        arbolesMonitorear: request.arbolesMonitorear,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    const item = toClienteFincaBaseResponseFromConfiguracionItem(saved);

    // Persiste la finca actualizada en `grpcFincaLoteDatabase` y fuerza la
    // recarga completa de los lotes de la finca (cada lote expone
    // `monitoreoCantidadArboles`, que el server deriva de este valor).
    await grpcFincaLoteDatabase.upsertFincaAsync(fromClienteFincaBaseResponse(item));
    await fx_createLoteGrpcService(item.id).recargarTodoAsync();

    return item;
  }
}
